import { Injectable } from '@angular/core';
import { ExporterService } from '../exporter.service';

@Injectable({
  providedIn: 'root'
})
export class ExportFacadeService {

  constructor(private oExporterService: ExporterService) { }

  exportToExcel(list: any[], excelFileName: string): void {
    this.oExporterService.exportToExcel(list, excelFileName);
  }
}
